import Draggable from "react-draggable";
import { Controller, DigitalIO, Display, EnergyMeter, FlowMeter, Indicator } from "../Devices";
import { handleDeviceDrop } from "./WidgetDropFunction";
import styles from "../NewPage.module.css";
import { handleDeviceMenu } from "./WidgetContentMenuFunction";
import { NewLineChart } from "../LineChart";
import { NewPieChart } from "../PieChart";
import { NewBarChart } from "../BarChart";
import { NewHistogram } from "../Histogram";
import { NewGauge } from "../Gauge";
import { NewProgressBar } from "../ProgressBar";
import { NewMovableTable } from "components/MovableTable/MovableTable";
import { NewToolBarGrid } from "../ToolBarGrid";
import { NewCircularProgressChart } from "../CircularProgress";
import { NewDoughnutChart } from "../DoughnutChart";
import { Stage, Layer, Line } from "react-konva";
import { useEffect, useRef, useState } from "react";
import CustomSwitch from "./components/CustomSwitch";
import { NewSlider } from "./components/Slider";

import Clock from "./components/Clock";
import BulbIcon from "components/BulbIcon";


function formatFromSeconds(sec) {
    const d = Math.floor(sec / 86400);
    const h = Math.floor((sec % 86400) / 3600);
    const m = Math.floor((sec % 3600) / 60);

    return `${d}d ${h}h ${m}m`;
}




export const GenerateNewDisplay = ({
    multipleDisplay,
    activeTabIndex,
    setDisplayPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexDisplay,
    updatedTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    setMultipleDisplay,
    tableData,
    pvSpecificChannel,
    openNewPage,
    currentPVChannel,
    setCurrentPVChannel,
    updatedMultipleDisplay,
    setUpdatedMultipleDisplay
}) => {
    return multipleDisplay.length > 1 &&
        multipleDisplay.slice(1).map((device, index) => {
            // Check if the device belongs to the active tab
            if (device.tabIndex === activeTabIndex) {

                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    fontSize: device.fontSize ? device.fontSize + "px" : "30px",
                    color: device.textColor ? device.textColor : "#D90211",
                    backgroundColor: device.bgColor ? device.bgColor : "#542A2A",
                    zIndex: device.zIndex ? device.zIndex : "1",
                };

                return (
                    <Draggable
                        key={index} // Add a unique key prop for each draggable element
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setDisplayPosition })
                        }
                    >
                        <div
                            className={`${styles.displayContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexDisplay,
                                        updatedTabIndexDisplay,
                                        setUpdatedTabIndexDisplay,
                                        setMultipleDisplay,
                                        multipleDisplay,
                                        bgColor: device.bgColor,
                                        textColor: device.textColor,
                                        fontSize: device.fontSize,
                                        updatedMultipleDisplay,
                                        setUpdatedMultipleDisplay
                                    }
                                )
                            }
                            id={`newdisplay-${index + 1}`}
                        >
                            <Display
                                device={device.deviceName}
                                tableData={tableData}
                                pvSpecificChannel={pvSpecificChannel[index]}
                                multipleDisplay={multipleDisplay}
                                openNewPage={openNewPage}
                                pvChannel={device.pvChannel}
                                index={index + 1}
                                currentPVChannel={currentPVChannel}
                                setCurrentPVChannel={setCurrentPVChannel}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null; // Don't render if the device doesn't belong to the active tab
            }
        })

}


export const GenerateNewIndicatores = ({
    multipleDevices,
    activeTabIndex,
    setDevicePosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tableData,
    pvSpecificChannel,
    openNewPage,
    currentPVChannel,
    setCurrentPVChannel
}) => {
    return multipleDevices.length > 1 &&
        multipleDevices.slice(1).map((device, index) => {
            // Check if the device belongs to the active tab
            if (device.tabIndex === activeTabIndex) {

                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setDevicePosition })
                        }
                    >
                        <div
                            className={`${styles.deviceContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally
                                    }
                                )
                            }
                        >
                            <Indicator
                                device={device.deviceName}
                                tableData={tableData}
                                pvSpecificChannel={pvSpecificChannel[index]}
                                multipleDevices={multipleDevices}
                                openNewPage={openNewPage}
                                pvChannel={device.pvChannel}
                                index={index + 1}
                                currentPVChannel={currentPVChannel}
                                setCurrentPVChannel={setCurrentPVChannel}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewController = ({
    multipleController,
    activeTabIndex,
    setControllerPosition,
    newControllerRefs,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tableData,
    svControllerChannel,
    pvControllerChannel,
    setMultipleController,
    currentPVController,
    currentSVContoller
}) => {
    return multipleController.length > 1 &&
        multipleController.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setControllerPosition })
                        }
                    >
                        <div
                            className={`${styles.deviceContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            ref={el => newControllerRefs.current[index] = el}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally
                                    }
                                )
                            }
                        >
                            <Controller
                                device={device.deviceName}
                                tableData={tableData}
                                multipleController={multipleController}
                                setMultipleController={setMultipleController}
                                currentPVChannel={currentPVController}
                                currentSVChannel={currentSVContoller}
                                pvControllerChannel={pvControllerChannel}
                                svControllerChannel={svControllerChannel}
                                index={index + 1}
                                pvChannel={device.pvChannel}
                                svChannel={device.svChannel}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewIO = ({
    multipleIO,
    activeTabIndex,
    setIOPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexIO,
    updatedTabIndexIO,
    setUpdatedTabIndexIO,
    setMultipleIO,
    tableData,

}) => {
    return multipleIO.length > 1 &&
        multipleIO.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    resize: "both",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setIOPosition })
                        }
                    >
                        <div
                            className={`${styles.ioContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexIO,
                                        updatedTabIndexIO,
                                        setUpdatedTabIndexIO,
                                        setMultipleIO,
                                        multipleIO,


                                    }
                                )
                            }
                            id={`newdigitalio-${index + 1}`}

                        >
                            <DigitalIO device={device.deviceName} onText={device.onText} offText={device.offText} onColor={device.onColor} offColor={device.offColor} tableData={tableData} channelName={device?.channelName} />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewFlowMeter = ({
    multipleFlowM,
    activeTabIndex,
    setFlowMPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tableData,
    currentPVFlowM,
    currentSVFlowM,
    pvFlowMChannels,
    svFlowMChannels

}) => {
    return multipleFlowM.length > 1 &&
        multipleFlowM.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setFlowMPosition })
                        }
                    >
                        <div
                            className={`${styles.flowMContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally
                                    }
                                )
                            }
                        >
                            <FlowMeter
                                device={device.deviceName}
                                tableData={tableData}
                                currentPVChannel={currentPVFlowM}
                                currentSVChannel={currentSVFlowM}
                                pvFlowMChannels={pvFlowMChannels[index]}
                                svFlowMChannels={svFlowMChannels[index]}
                                pvChannel={device.pvChannel}
                                svChannel={device.svChannel}
                                multipleFlowM={multipleFlowM}
                                index={index + 1}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewEnergyMeter = ({
    multipleEnergyM,
    activeTabIndex,
    setEnergyMPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tableData,
    currentPVEnergyM,
    currentSVEnergyM,
    pvEnergyMChannels,
    svEnergyMChannels
}) => {
    return multipleEnergyM.length > 1 &&
        multipleEnergyM.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setEnergyMPosition })
                        }
                    >
                        <div
                            className={`${styles.energyMContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally
                                    }
                                )
                            }
                        >
                            <EnergyMeter
                                device={device.deviceName}
                                tableData={tableData}
                                currentPVChannel={currentPVEnergyM}
                                currentSVChannel={currentSVEnergyM}
                                pvEnergyMChannels={pvEnergyMChannels}
                                svEnergyMChannels={svEnergyMChannels}
                                pvChannel={device.pvChannel}
                                svChannel={device.svChannel}
                                svChannel2={device.svChannel2}
                                svChannel3={device.svChannel3}
                                multipleEnergyM={multipleEnergyM}
                                index={index + 1}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewText = ({
    multipleText,
    activeTabIndex,
    setTextPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexText,
    updatedTabIndexText,
    setUpdatedTabIndexText,
    setMultipleText,
    updatedMultipleText,
    setUpdatedMultipleText,
    tableData
}) => {
    return multipleText.length > 1 &&
        multipleText.slice(1).map((device, index) => {

            const { pvChannel, text } = device;

            const channel = tableData.find((data) => data.Header === pvChannel);
            let statusVal;

            if (channel) {

                if (channel.Header.includes("Event_")) {

                    statusVal = formatFromSeconds(channel?.val)

                } else {
                    statusVal = channel?.val;

                }

            } else {

                statusVal = text;

            }


            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    fontSize: device.fontSize ? device.fontSize + "px" : "30px",
                    color: device.textColor ? device.textColor : "#000000",
                    backgroundColor: device?.isTransparent ? "transparent" : device.bgColor ? device.bgColor : "#ffffff",
                    resize: "both",
                    padding: "0.6rem 1rem",
                    display: "flex",
                    wordBreak: "break-word",
                    justifyContent: device.alignHorizontally ? device.alignHorizontally : "start",
                    alignItems: device.alignVertically ? device.alignVertically : "start",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setTextPosition })
                        }
                    >
                        <div
                            className={`${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexText,
                                        updatedTabIndexText,
                                        setUpdatedTabIndexText,
                                        setMultipleText,
                                        multipleText,
                                        bgColor: device.bgColor,
                                        textColor: device.textColor,
                                        fontSize: device.fontSize,
                                        text: device.text,
                                        alignVertically: device.alignVertically,
                                        alignHorizontally: device.alignHorizontally,
                                        updatedMultipleText,
                                        setUpdatedMultipleText
                                    }
                                )
                            }
                            id={`newtext-${index + 1}`}
                        >
                            {statusVal}
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewMotor = ({
    setMotorPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexMotor,
    updatedTabIndexMotor,
    setUpdatedTabIndexMotor,
    multipleMotor,
    setMultipleMotor,
    updatedMultipleMotor,
    setUpdatedMultipleMotor
}) => {
    return multipleMotor?.length > 1 &&
        multipleMotor?.slice(1).map((image, imgIndex) => {
            if (image.tabIndex === activeTabIndex) {

                const imageStyle = {
                    resize: "both",
                    width: "250px",
                    height: "150px",
                    zIndex: image.zIndex ? image.zIndex : "1",
                };

                return (
                    <Draggable
                        key={imgIndex} // Add a unique key prop for each draggable element
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, imgIndex + 1, image.type, { setMotorPosition })
                        }

                    >
                        <div
                            className={`${styles.imgToDisplay} ${styles.addImg}`}
                            style={imageStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    imgIndex + 1,
                                    image,
                                    image.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexMotor,
                                        updatedTabIndexMotor,
                                        setUpdatedTabIndexMotor,
                                        multipleMotor,
                                        setMultipleMotor,
                                        updatedMultipleMotor,
                                        setUpdatedMultipleMotor
                                    }
                                )
                            }
                            id={`newmotor-${imgIndex + 1}`}
                        >

                            <img
                                src={image.image}
                                alt=""
                                className={styles.addImg}

                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null; // Don't render if the device doesn't belong to the active tab
            }
        })
}


export const GenerateNewLineChart = ({
    setLineChartPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexLineChart,
    updatedTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    data,
    endHours,
    endMinutes,
    oneDayDataTs,
    updatedMultipleLineChart,
    setUpdatedMultipleLineChart

}) => {
    return multipleLineCharts.length > 1 &&
        multipleLineCharts.slice(1).map((device, index) => {

            const { width, height } = updatedMultipleLineChart.slice(1)[index];

            const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1",
                    resize: "both",

                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setLineChartPosition })
                        }
                    >
                        <div
                            className={`${styles.lineChartContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexLineChart,
                                        updatedTabIndexLineChart,
                                        setUpdatedTabIndexLineChart,
                                        multipleLineCharts,
                                        setMultipleLineCharts,
                                        updatedMultipleLineChart,
                                        setUpdatedMultipleLineChart
                                    }
                                )
                            }
                            id={`newlinechart-${index + 1}`}
                        >

                            <NewLineChart
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={filteredDataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                openNewPage={openNewPage}
                                chartChannel={device.chartChannel}
                                data={data}
                                endHours={device?.hour || 0}
                                endMinutes={device?.minute || 0}
                                oneDayDataTs={oneDayDataTs}
                                lineStyle={device?.lineStyle}
                                isCurveLine={device?.isCurveLine}
                                isSteppedLine={device?.isSteppedLine}
                                minY={device?.minY}
                                maxY={device?.maxY}
                                width={width}
                                height={height}
                                xInterval={device?.xInterval}
                                yInterval={device?.yInterval}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewPieChart = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexPieChart,
    updatedTabIndexPieChart,
    setUpdatedTabIndexPieChart,
    multiplePieChart,
    setMultiplePieChart,
    setPieChartPosition,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    pieChartChannels,
    updatedMultiplePieChart,
    setUpdatedMultiplePieChart

}) => {
    return multiplePieChart.length > 1 &&
        multiplePieChart.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {

                const deviceStyle = {
                    position: "absolute",
                    left: device.x === 0 ? "0%" : device.x,
                    top: device.y === 0 ? "40px" : device.y,
                    width:
                        device.width === undefined ? "27%" : device.width,
                    zIndex: device.zIndex ? device.zIndex : "1"

                };

                const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setPieChartPosition })
                        }
                    >
                        <div
                            className={`${styles.pieChartContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexPieChart,
                                        updatedTabIndexPieChart,
                                        setUpdatedTabIndexPieChart,
                                        multiplePieChart,
                                        setMultiplePieChart,
                                        updatedMultiplePieChart,
                                        setUpdatedMultiplePieChart
                                    }
                                )
                            }
                            id={`newpiechart-${index + 1}`}
                        >

                            <NewPieChart
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={filteredDataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                chartChannel={device.chartChannel}
                                openNewPage={openNewPage}
                                pieChartChannels={pieChartChannels}
                                channelsGroup={device?.channelsGroup}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewBarChart = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexBarChart,
    updatedTabIndexBarChart,
    setUpdatedTabIndexBarChart,
    multipleBarChart,
    setMultipleBarChart,
    setBarChartPosition,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    pieChartChannels,
    updatedMultipleBarChart,
    setUpdatedMultipleBarChart
}) => {
    return multipleBarChart.length > 1 &&
        multipleBarChart.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {

                const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"

                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setBarChartPosition })
                        }
                    >
                        <div
                            className={`${styles.barChartContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexBarChart,
                                        updatedTabIndexBarChart,
                                        setUpdatedTabIndexBarChart,
                                        multipleBarChart,
                                        setMultipleBarChart,
                                        updatedMultipleBarChart,
                                        setUpdatedMultipleBarChart
                                    }
                                )
                            }
                            id={`newbarchart-${index + 1}`}
                        >

                            <NewBarChart
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={filteredDataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                openNewPage={openNewPage}
                                pieChartChannels={pieChartChannels}
                                chartChannel={device.chartChannel}
                                channelsGroup={device?.channelsGroup}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewHistogram = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexHistogram,
    updatedTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    multipleHistogram,
    setMultipleHistogram,
    setHistogramPosition,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    endHours,
    endMinutes,
    oneDayDataTs,
    updatedMultipleHistogram,
    setUpdatedMultipleHistogram

}) => {
    return multipleHistogram.length > 1 &&
        multipleHistogram.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));


                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setHistogramPosition })
                        }
                    >
                        <div
                            className={`${styles.barChartContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexHistogram,
                                        updatedTabIndexHistogram,
                                        setUpdatedTabIndexHistogram,
                                        multipleHistogram,
                                        setMultipleHistogram,
                                        updatedMultipleHistogram,
                                        setUpdatedMultipleHistogram
                                    }
                                )
                            }
                            id={`newhistogram-${index + 1}`}
                        >

                            <NewHistogram
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={filteredDataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                openNewPage={openNewPage}
                                chartChannel={device.chartChannel}
                                endHours={endHours}
                                endMinutes={endMinutes}
                                oneDayDataTs={oneDayDataTs}
                                channelsGroup={device?.channelsGroup}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}

export const GenerateNewGauge = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexGauge,
    updatedTabIndexGauge,
    setUpdatedTabIndexGauge,
    multipleGauge,
    setMultipleGauge,
    setGaugePosition,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    startPoint,
    endPoint,
    updatedMultipleGauge,
    setUpdatedMultipleGauge
}) => {
    return multipleGauge.length > 1 &&
        multipleGauge.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setGaugePosition })
                        }
                    >
                        <div
                            className={`${styles.gaugeContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexGauge,
                                        updatedTabIndexGauge,
                                        setUpdatedTabIndexGauge,
                                        multipleGauge,
                                        setMultipleGauge,
                                        updatedMultipleGauge,
                                        setUpdatedMultipleGauge
                                    }
                                )
                            }
                            id={`newgauge-${index + 1}`}
                        >
                            <NewGauge
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={dataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                openNewPage={openNewPage}
                                chartChannel={device.chartChannel}
                                index={index}
                                device={device}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewProgressbar = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexProgress,
    updatedTabIndexProgress,
    setUpdatedTabIndexProgress,
    multipleProgress,
    setMultipleProgress,
    setProgressPosition,
    rotateBar,
    dateTimesLive,
    channelNames,
    dataArrLive,
    getRandomColor,
    tabIndexPieChart,
    openNewPage,
    updatedMultipleProgress,
    setUpdatedMultipleProgress
}) => {
    return multipleProgress.length > 1 &&
        multipleProgress.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setProgressPosition })
                        }
                    >
                        <div
                            className={`${styles.progressContainer} ${styles.addImg}`}
                            style={{
                                display: rotateBar ? "flex" : null,
                                justifyContent: rotateBar ? "center" : null,
                                alignItems: rotateBar ? "center" : null,
                                height: rotateBar ? "37vh" : "",
                                position: "absolute",
                                left: device.x === undefined ? "0%" : device.x,
                                top: device.y === undefined ? "40px" : device.y,
                                zIndex: device.zIndex ? device.zIndex : "1"
                            }}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexProgress,
                                        updatedTabIndexProgress,
                                        setUpdatedTabIndexProgress,
                                        multipleProgress,
                                        setMultipleProgress,
                                        updatedMultipleProgress,
                                        setUpdatedMultipleProgress
                                    }
                                )
                            }
                            id={`newprogressbar-${index + 1}`}
                        >
                            <NewProgressBar
                                dateTimesLive={dateTimesLive}
                                channelNames={channelNames}
                                dataArrLive={dataArrLive}
                                getRandomColor={getRandomColor}
                                tabIndexPieChart={tabIndexPieChart}
                                selectedTabIndex={activeTabIndex}
                                openNewPage={openNewPage}
                                minVal={device.minVal}
                                maxVal={device.maxVal}
                                chartChannel={device.chartChannel}
                                chartIndex={index}
                                rotateBar={rotateBar}
                                fontSize={device.fontSize}
                                bgColor={device.bgColor}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenarateNewTable = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexTable,
    updatedTabIndexTable,
    setUpdatedTabIndexTable,
    multipleTable,
    setMultipleTable,
    setTablePosition,
    channelNames,
    dataArrLive,
    updatedMultipleTable,
    setUpdatedMultipleTable
}) => {
    return multipleTable.length > 1 &&
        multipleTable.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setTablePosition })
                        }
                    >
                        <div
                            className={`${styles.tableContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexTable,
                                        updatedTabIndexTable,
                                        setUpdatedTabIndexTable,
                                        multipleTable,
                                        setMultipleTable,
                                        updatedMultipleTable,
                                        setUpdatedMultipleTable
                                    }
                                )
                            }
                            id={`newtable-${index + 1}`}
                        >
                            <NewMovableTable
                                channelNames={channelNames}
                                dataArrLive={dataArrLive}
                                chartChannel={device.chartChannel}
                                isColumn={device.column}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewGrid = ({
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexGrid,
    updatedTabIndexGrid,
    setUpdatedTabIndexGrid,
    multipleGrid,
    setMultipleGrid,
    setGridPosition,
    tableData,
    updatedMultipleGrid,
    setUpdatedMultipleGrid
}) => {
    return multipleGrid.length > 1 &&
        multipleGrid.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setGridPosition })
                        }
                    >
                        <div
                            className={`${styles.gridContainer} ${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexGrid,
                                        updatedTabIndexGrid,
                                        setUpdatedTabIndexGrid,
                                        multipleGrid,
                                        setMultipleGrid,
                                        updatedMultipleGrid,
                                        setUpdatedMultipleGrid
                                    }
                                )
                            }
                            id={`newgrid-${index + 1}`}
                        >
                            <NewToolBarGrid
                                tableData={tableData}
                                gridIndex={index + 1}
                                chartChannel={device.chartChannel}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}



export const GenerateNewCircularProgress = ({
    multipleCircularProgress,
    activeTabIndex,
    setCircularProgressPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    tempTabIndexCircularProgress,
    updatedTabIndexCircularProgress,
    setMultipleCircularProgress,
    setUpdatedTabIndexCircularProgress,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    setSelectedDeviceId,
    setUpdatedMultipleCircularProgress,
    updatedMultipleCircularProgress,
    dateTimesLive,
    dataArrLive,

}) => {
    return multipleCircularProgress.length > 1 &&
        multipleCircularProgress.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {

                const style = {
                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    padding: ".2rem",
                    resize: "both",
                    width: "100px",
                    height: "100px",
                    zIndex: device.zIndex ? device.zIndex : "1"
                }
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setCircularProgressPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={style}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        tempTabIndexCircularProgress,
                                        updatedTabIndexCircularProgress,
                                        setUpdatedTabIndexCircularProgress,
                                        multipleCircularProgress,
                                        setMultipleCircularProgress,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        setSelectedDeviceId,
                                        setUpdatedMultipleCircularProgress,
                                        updatedMultipleCircularProgress
                                    }
                                )
                            }
                            id={`newcircularprogress-${index + 1}`}
                        >
                            <NewCircularProgressChart
                                progress={60}
                                dateTimesLive={dateTimesLive}
                                dataArrLive={dataArrLive}
                                chartChannel={device.chartChannel}
                                maxVal={device.maxVal}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewDoughnutChart = ({
    multipleDoughnut,
    activeTabIndex,
    setDoughnutPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    tempTabIndexDoughnut,
    updatedTabIndexDoughnut,
    setMultipleDoughnut,
    setUpdatedTabIndexDoughnut,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    setSelectedDeviceId,
    setUpdatedMultipleDoughnut,
    updatedMultipleDoughnut,
    dateTimesLive,
    dataArrLive,
    getRandomColor

}) => {
    return multipleDoughnut.length > 1 &&
        multipleDoughnut.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {

                const style = {
                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    padding: ".2rem",
                    resize: "both",
                    width: "150px",
                    height: "150px",
                    zIndex: device.zIndex ? device.zIndex : "1"
                }

                const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setDoughnutPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={style}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        activeTabIndex,
                                        setTempImages,
                                        setUpdatedImages,
                                        tempTabIndexDoughnut,
                                        updatedTabIndexDoughnut,
                                        setUpdatedTabIndexDoughnut,
                                        multipleDoughnut,
                                        setMultipleDoughnut,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        setSelectedDeviceId,
                                        setUpdatedMultipleDoughnut,
                                        updatedMultipleDoughnut
                                    }
                                )
                            }
                            id={`newdoughnut-${index + 1}`}
                        >
                            <NewDoughnutChart

                                dataArrLive={filteredDataArrLive}
                                chartChannel={device.chartChannel}
                                getRandomColor={getRandomColor}

                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}



export const GenerateNewLines = ({
    multipleLines,
    activeTabIndex,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tableData,
    setLinePosition
}) => {


    return multipleLines.length > 1 &&
        multipleLines.slice(1).map((line, index) => {
            if (line.tabIndex === activeTabIndex) {

                return (
                    <Draggable
                        key={index}
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, line.type, { setLinePosition })
                        }
                        defaultPosition={{ x: line.x, y: line.y }}
                        bounds="parent"
                    >


                        <div
                            style={{
                                position: "absolute",
                                width: `${line.width}px`,
                                height: `${line.height}px`,
                            }}
                            className={styles.addImg}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    line,
                                    line.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally
                                    }


                                )
                            }
                        >
                            <div
                                style={{
                                    position: "absolute",

                                    left: line.deltaX >= 0 ? 0 : line.width,
                                    top: line.deltaY >= 0 ? 0 : line.height,

                                    width: `${line.length}px`,
                                    height: "2px",
                                    backgroundColor: line?.bgColor ? line.bgColor : "black",

                                    transformOrigin: "0 0",
                                    transform: `rotate(${line.angle}deg)`,

                                }}



                            ></div>
                        </div>

                    </Draggable>
                );
            } else {
                return null;
            }
        })

}

export const GenerateNewSquare = ({
    multipleSquare,
    activeTabIndex,
    setSquarePosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexSquare,
    updatedTabIndexSquare,
    setUpdatedTabIndexSquare,
    updatedMultipleSquare,
    setUpdatedMultipleSquare,
    setMultipleSquare,
    tableData
}) => {

    return multipleSquare.length > 1 &&
        multipleSquare.slice(1).map((device, index) => {

            const {
                onText, offText, text, onColor, offColor, fontSize, bgColor,
                channelName, textColor, hideChannel, hideValue, borderRadius,
                blinkChannel, blinkValue, blinkFunction, blinkFrequency
            } = device;

            const channel = tableData.find(d => d.Header === channelName?.PV);
            const hideChannelData = tableData.find(d => d.Header === hideChannel);
            const blinkChannelData = tableData.find(d => d.Header === blinkChannel);

            let statusText = text;
            let statusColor = bgColor;
            let isHide = false;

            if (channel) {
                if (channel.val === 1) {
                    statusText = onText;
                    statusColor = onColor;
                } else if (channel.val === 0) {
                    statusText = offText;
                    statusColor = offColor;
                }
            }

            if (hideChannelData && hideValue !== undefined) {
                isHide = hideChannelData.val.toString() === hideValue.toString();
            }


            // --------------------------------

            if (device.tabIndex !== activeTabIndex) return null;

            const deviceStyle = {
                width: "100px",
                height: "100px",
                position: "absolute",
                left: "0px",
                top: "40px",
                border: "1px solid black",
                background: statusColor || "white",
                resize: "both",
                display: isHide ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: fontSize ? fontSize + "px" : "14px",
                color: textColor || "black",
                borderRadius: `${borderRadius?.toString()}%` ? `${borderRadius?.toString()}%` : "none",
                zIndex: device.zIndex || "1",

            };

            return (
                <Draggable
                    bounds="parent"
                    onStop={(e, data) =>
                        handleDeviceDrop(e, data, index + 1, device.type, { setSquarePosition })
                    }
                >
                    <div
                        className={`${styles.addImg}`}
                        style={deviceStyle}
                        id={`newsquare-${index + 1}`}
                        onContextMenu={(event) =>
                            handleDeviceMenu(event, index + 1, device, device.type, {
                                activeTabIndex,
                                setDeviceMenuPosition,
                                setClickedDeviceIndex,
                                setIsDeviceMenu,
                                setSelectedDevice,
                                setCurrentDevice,
                                tempImages,
                                setTempImages,
                                setUpdatedImages,
                                setAddedText,
                                setBgColor,
                                setTextBgColor,
                                setTextColor,
                                setWidgetTextColor,
                                setFontSize,
                                setTextFontSize,
                                setTextAlignVertically,
                                setTextAlignHorizontally,
                                tempTabIndexSquare,
                                updatedTabIndexSquare,
                                setUpdatedTabIndexSquare,
                                updatedMultipleSquare,
                                setUpdatedMultipleSquare
                            })
                        }
                    >
                        {statusText}
                    </div>
                </Draggable>
            );
        });
};



export const GenerateNewCircle = ({
    multipleCircle,
    activeTabIndex,
    setSquarePosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexCircle,
    updatedTabIndexCircle,
    setUpdatedTabIndexCircle,
    updatedMultipleCircle,
    setUpdatedMultipleCircle,
    setMultipleCircle,
    setCirclePosition,
    tableData
}) => {
    return multipleCircle.length > 1 &&
        multipleCircle.slice(1).map((device, index) => {


            const { onText, offText, text, onColor, offColor, fontSize, bgColor, channelName, textColor, hideChannel, hideValue } = device;

            const channel = tableData.find((data) => data.Header === channelName?.PV);
            const selectedHideChannel = tableData.find((data) => data.Header === hideChannel);

            let statusText;
            let statusColor;
            let isHide

            if (channel) {
                if (channel?.val === 1) {
                    statusText = onText;
                    statusColor = onColor
                } else if (channel?.val === 0) {
                    statusText = offText;
                    statusColor = offColor
                } else {
                    statusText = text;
                    statusColor = bgColor;
                }
            } else {
                statusText = text;
                statusColor = bgColor;
            }

            if (selectedHideChannel) {
                if (hideValue) {
                    isHide = selectedHideChannel?.val.toString() === hideValue.toString() ? true : false;
                }

            }


            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    width: "100px",
                    height: "100px",
                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    border: "1px solid black",
                    background: statusColor ? statusColor : "white",
                    borderRadius: "50%", // ✅ Make it circular
                    resize: "both",
                    overflow: "hidden", // Prevent content overflow
                    display: isHide ? "none" : "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: fontSize ? fontSize + "px" : "14px",
                    color: textColor ? textColor : "black",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setCirclePosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexCircle,
                                        updatedTabIndexCircle,
                                        setUpdatedTabIndexCircle,
                                        updatedMultipleCircle,
                                        setUpdatedMultipleCircle
                                    }
                                )
                            }
                            id={`newcircle-${index + 1}`}
                        >
                            {statusText}
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
};


export const GenerateNewSwitch = ({
    multipleSwitch,
    activeTabIndex,
    setSwitchPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexSwitch,
    updatedTabIndexSwitch,
    setUpdatedTabIndexSwitch,
    updatedMultipleSwitch,
    setUpdatedMultipleSwitch,
    setMultipleSwitch,
    dataArrLive
}) => {
    return multipleSwitch.length > 1 &&
        multipleSwitch.slice(1).map((device, index) => {
            let isOn = 0;
            if (device?.chartChannel) {
                const matchedDatasets =
                    device?.chartChannel?.length === 0
                        ? null
                        : dataArrLive?.find(
                            (dataset) => dataset.label === device?.chartChannel[0]
                        );
                const currentVal = matchedDatasets
                    ? matchedDatasets?.data.slice(-1)
                    : [0];


                if (currentVal && currentVal[0]) {
                    isOn = parseInt(currentVal[0]) === 1 ? true : false
                }

            }




            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {

                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "80px",
                    height: "50px",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setSwitchPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexSwitch,
                                        updatedTabIndexSwitch,
                                        setUpdatedTabIndexSwitch,
                                        updatedMultipleSwitch,
                                        setUpdatedMultipleSwitch
                                    }
                                )
                            }
                            id={`newswitch-${index + 1}`}
                        >
                            <CustomSwitch
                                on={isOn}
                                bgColor={device?.bgColor}
                                index={index + 1}
                                multipleSwitch={multipleSwitch}
                                setMultipleSwitch={setMultipleSwitch}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
}


export const GenerateNewCheckbox = ({
    multipleCheckbox,
    activeTabIndex,
    setCheckboxPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexCheckbox,
    updatedTabIndexCheckbox,
    setUpdatedTabIndexCheckbox,
    updatedMultipleCheckbox,
    setUpdatedMultipleCheckbox,
    setMultipleCheckbox,
    handleSelectCheckbox

}) => {
    return multipleCheckbox.length > 1 &&
        multipleCheckbox.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {

                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: device.width ? device.width : "15px",
                    height: device.height ? device.height : "15px",
                    zIndex: device.zIndex ? device.zIndex : "1",
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setCheckboxPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexCheckbox,
                                        updatedTabIndexCheckbox,
                                        setUpdatedTabIndexCheckbox,
                                        updatedMultipleCheckbox,
                                        setUpdatedMultipleCheckbox
                                    }
                                )
                            }
                            id={`newcheckbox-${index + 1}`}
                        >
                            <input type="checkbox" style={{ width: "100%", height: "100%" }} checked={device.on}
                                onChange={() => handleSelectCheckbox(index + 1)}
                            />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
}

export const GenerateNewRadio = ({
    multipleRadio,
    activeTabIndex,
    setRadioPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexRadio,
    updatedTabIndexRadio,
    setUpdatedTabIndexRadio,
    updatedMultipleRadio,
    setUpdatedMultipleRadio,
    setMultipleRadio,
    handleSelectRadioButton
}) => {
    return multipleRadio.length > 1 &&
        multipleRadio.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {

                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "0.5rem",
                    alignItems: "center",
                    width: device.width ? device.width : "50px",
                    height: device.height ? device.height : "50px",
                    resize: "both",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setRadioPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexRadio,
                                        updatedTabIndexRadio,
                                        setUpdatedTabIndexRadio,
                                        updatedMultipleRadio,
                                        setUpdatedMultipleRadio
                                    }
                                )
                            }
                            id={`newradio-${index + 1}`}
                        >
                            {device?.points.map((btn, i) => (
                                <input
                                    type="radio"
                                    name={`group${index}`}
                                    style={{ flex: "1", width: "100%", cursor: "pointer" }}
                                    checked={device.selectedIndex === i}
                                    onChange={() => handleSelectRadioButton(i, device.type, index + 1)} />
                            ))}
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
}


export const GenerateNewSlider = ({
    multipleSlider,
    activeTabIndex,
    setSliderPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexSlider,
    updatedTabIndexSlider,
    setUpdatedTabIndexSlider,
    updatedMultipleSlider,
    setUpdatedMultipleSlider,
    dataArrLive,
    dateTimesLive

}) => {




    return multipleSlider.length > 1 &&
        multipleSlider.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {

                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: device.width ? device.width : "190px",
                    resize: "both",
                    color: device?.textColor ? device?.textColor : "black",
                    zIndex: device.zIndex ? device.zIndex : "1",
                };


                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setSliderPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexSlider,
                                        updatedTabIndexSlider,
                                        setUpdatedTabIndexSlider,
                                        updatedMultipleSlider,
                                        setUpdatedMultipleSlider
                                    }
                                )
                            }
                            id={`newslider-${index + 1}`}
                        >
                            <NewSlider
                                maxVal={device?.maxVal}
                                minVal={device?.minVal}
                                dateTimesLive={dateTimesLive}
                                dataArrLive={dataArrLive}
                                chartChannel={[device?.chartChannel]}
                                bgColor={device?.bgColor}
                                fontSize={device?.fontSize}
                            />

                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
}


export const GenerateNewLamp = ({
    multipleLamp,
    activeTabIndex,
    setLampPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexLamp,
    updatedTabIndexLamp,
    setUpdatedTabIndexLamp,
    updatedMultipleLamp,
    setUpdatedMultipleLamp,
    tableData
}) => {




    return multipleLamp.length > 1 &&
        multipleLamp.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {

                let lampColor = "grey";

                if (device?.chartChannel && Array.isArray(device?.chartChannel) && device?.chartChannel.length > 0) {

                    const statusChannel = tableData.find(
                        (d) => d.Header === device?.chartChannel[0]
                    );

                    if (statusChannel && statusChannel.val) {

                        const foundLampStatus = device?.lampStatus?.filter((status) => Number(status.conditionValue) === Number(statusChannel.val))

                        if (foundLampStatus.length > 0) {
                            lampColor = foundLampStatus[0]?.color
                        }

                    }

                }

                const deviceStyle = {

                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100px",
                    height: "100px",
                    resize: "both",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };


                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setLampPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexLamp,
                                        updatedTabIndexLamp,
                                        setUpdatedTabIndexLamp,
                                        updatedMultipleLamp,
                                        setUpdatedMultipleLamp
                                    }
                                )
                            }
                            id={`newlamp-${index + 1}`}
                        >

                            <BulbIcon color={lampColor} />

                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
}



export const GenerateNewPush = ({
    multiplePush,
    activeTabIndex,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexPush,
    updatedTabIndexPush,
    setUpdatedTabIndexPush,
    updatedMultiplePush,
    setUpdatedMultiplePush,
    setMultiplePush,
    setPushPosition
}) => {
    return multiplePush.length > 1 &&
        multiplePush.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    width: "100px",
                    height: "100px",
                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    border: "1px solid black",
                    background: device.bgColor ? device.bgColor : "white",
                    borderRadius: "50%", // ✅ Make it circular
                    resize: "both",
                    overflow: "hidden", // Prevent content overflow
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setPushPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexPush,
                                        updatedTabIndexPush,
                                        setUpdatedTabIndexPush,
                                        updatedMultiplePush,
                                        setUpdatedMultiplePush
                                    }
                                )
                            }
                            id={`newpush-${index + 1}`}
                        >
                            <span>OFF</span>
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
};



export const GenerateNewLink = ({
    multipleLink,
    activeTabIndex,
    setLinkPosition,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexLink,
    updatedTabIndexLink,
    setUpdatedTabIndexLink,
    setMultipleLink,
    updatedMultipleLink,
    setUpdatedMultipleLink,
}) => {
    return multipleLink.length > 1 &&
        multipleLink.slice(1).map((device, index) => {

            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    position: "absolute",
                    left: device.x === undefined ? "0%" : device.x,
                    top: device.y === undefined ? "40px" : device.y,
                    fontSize: device.fontSize ? device.fontSize + "px" : "30px",
                    color: device.textColor ? device.textColor : "#000000",
                    backgroundColor: device.bgColor ? device.bgColor : "#ffffff",
                    resize: "both",
                    padding: "0.6rem 1rem",
                    display: "flex",
                    wordBreak: "break-word",
                    justifyContent: device.alignHorizontally ? device.alignHorizontally : "start",
                    alignItems: device.alignVertically ? device.alignVertically : "start",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };
                return (
                    <Draggable
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setLinkPosition })
                        }
                    >
                        <div
                            className={`${styles.addImg}`}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexLink,
                                        updatedTabIndexLink,
                                        setUpdatedTabIndexLink,
                                        setMultipleLink,
                                        multipleLink,
                                        bgColor: device.bgColor,
                                        textColor: device.textColor,
                                        fontSize: device.fontSize,
                                        text: device.text,
                                        alignVertically: device.alignVertically,
                                        alignHorizontally: device.alignHorizontally,
                                        updatedMultipleLink,
                                        setUpdatedMultipleLink
                                    }
                                )
                            }
                            id={`newlink-${index + 1}`}
                        >
                            {device.text}
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        })
}


export const GenerateNewClock = ({
    multipleClock,
    activeTabIndex,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    tempTabIndexClock,
    updatedTabIndexClock,
    setUpdatedTabIndexClock,
    updatedMultipleClock,
    setUpdatedMultipleClock,
    setMultipleClock,
    setClockPosition
}) => {
    return multipleClock.length > 1 &&
        multipleClock.slice(1).map((device, index) => {
            if (device.tabIndex === activeTabIndex) {
                const deviceStyle = {
                    width: "100px",
                    height: "100px",
                    position: "absolute",
                    left: "0px",
                    top: "40px",
                    background: "transparent",
                    resize: "both",
                    overflow: "hidden", // Prevent content overflow
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: device.zIndex ? device.zIndex : "1"
                };

                return (
                    <Draggable
                        key={index}
                        bounds="parent"
                        onStop={(e, data) =>
                            handleDeviceDrop(e, data, index + 1, device.type, { setClockPosition })
                        }
                    >
                        <div
                            className={styles.addImg}
                            style={deviceStyle}
                            onContextMenu={(event) =>
                                handleDeviceMenu(
                                    event,
                                    index + 1,
                                    device,
                                    device.type,
                                    {
                                        activeTabIndex,
                                        setDeviceMenuPosition,
                                        setClickedDeviceIndex,
                                        setIsDeviceMenu,
                                        setSelectedDevice,
                                        setCurrentDevice,
                                        tempImages,
                                        setTempImages,
                                        setUpdatedImages,
                                        setAddedText,
                                        setBgColor,
                                        setTextBgColor,
                                        setTextColor,
                                        setWidgetTextColor,
                                        setFontSize,
                                        setTextFontSize,
                                        setTextAlignVertically,
                                        setTextAlignHorizontally,
                                        tempTabIndexClock,
                                        updatedTabIndexClock,
                                        setUpdatedTabIndexClock,
                                        updatedMultipleClock,
                                        setUpdatedMultipleClock
                                    }
                                )
                            }
                            id={`newclock-${index + 1}`}
                        >
                            <Clock />
                        </div>
                    </Draggable>
                );
            } else {
                return null;
            }
        });
};





export const GenerateNewPolygon = ({
    multiplePolygone,
    activeTabIndex,
    setPolygonePosition,
    setUpdatedMultiplePolygone,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    updatedMultiplePolygone

}) => {
    return (
        multiplePolygone.length > 1 &&
        multiplePolygone.slice(1).map((polygon, index) => {
            if (polygon.tabIndex !== activeTabIndex) return null;

            return (
                <ResizablePolygonWidget
                    key={index}
                    polygon={polygon}
                    index={index + 1}
                    setPolygonePosition={setPolygonePosition}
                    setUpdatedMultiplePolygone={setUpdatedMultiplePolygone}
                    multiplePolygone={multiplePolygone}
                    activeTabIndex={activeTabIndex}
                    setDeviceMenuPosition={setDeviceMenuPosition}
                    setClickedDeviceIndex={setClickedDeviceIndex}
                    setIsDeviceMenu={setIsDeviceMenu}
                    setSelectedDevice={setSelectedDevice}
                    setCurrentDevice={setCurrentDevice}
                    tempImages={tempImages}
                    setTempImages={setTempImages}
                    setUpdatedImages={setUpdatedImages}
                    setAddedText={setAddedText}
                    setBgColor={setBgColor}
                    setTextBgColor={setTextBgColor}
                    setTextColor={setTextColor}
                    setWidgetTextColor={setWidgetTextColor}
                    setFontSize={setFontSize}
                    setTextFontSize={setTextFontSize}
                    setTextAlignVertically={setTextAlignVertically}
                    setTextAlignHorizontally={setTextAlignHorizontally}
                    updatedMultiplePolygone={updatedMultiplePolygone}
                />
            );
        })
    );
};

function ResizablePolygonWidget({ polygon, index, setPolygonePosition, setUpdatedMultiplePolygone, multiplePolygone,
    activeTabIndex,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    updatedMultiplePolygone
}) {
    const containerRef = useRef(null);
    const [size, setSize] = useState({
        width: polygon.width,
        height: polygon.height,
    });

    const [points, setPoints] = useState([])

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setSize({ width: clientWidth, height: clientHeight });
                const copiedMultiplePolygone = [...updatedMultiplePolygone];
                copiedMultiplePolygone[index].width = clientWidth;
                copiedMultiplePolygone[index].height = clientHeight;
                setUpdatedMultiplePolygone(copiedMultiplePolygone);

            }
        });

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (multiplePolygone.length > 0) {
            const scaleX = size.width / polygon.width;
            const scaleY = size.height / polygon.height;

            const scaledPoints = polygon.points.map((val, i) =>
                i % 2 === 0 ? val * scaleX : val * scaleY
            );
            const copiedMultiplePolygone = [...updatedMultiplePolygone];
            copiedMultiplePolygone[index].points = scaledPoints;
            setUpdatedMultiplePolygone(copiedMultiplePolygone);
            setPoints(scaledPoints)
        }

    }, [size, multiplePolygone]);




    return (
        <Draggable
            bounds="parent"
            defaultPosition={{ x: polygon.x, y: polygon.y }}
            onStop={(e, data) =>
                handleDeviceDrop(e, data, index + 1, polygon.type, {
                    setPolygonePosition,
                })
            }
        >
            <div
                ref={containerRef}
                style={{
                    position: "absolute",
                    width: polygon.width,
                    height: polygon.height,
                    resize: "both",
                    overflow: "hidden",
                    pointerEvents: "auto",
                    zIndex: polygon.zIndex ? polygon.zIndex : "1"
                }}
                className={styles.addImg}
                onContextMenu={(event) =>
                    handleDeviceMenu(
                        event,
                        index,
                        polygon,
                        polygon.type,
                        {
                            activeTabIndex,
                            setDeviceMenuPosition,
                            setClickedDeviceIndex,
                            setIsDeviceMenu,
                            setSelectedDevice,
                            setCurrentDevice,
                            tempImages,
                            setTempImages,
                            setUpdatedImages,
                            setAddedText,
                            setBgColor,
                            setTextBgColor,
                            setTextColor,
                            setWidgetTextColor,
                            setFontSize,
                            setTextFontSize,
                            setTextAlignVertically,
                            setTextAlignHorizontally
                        }
                    )
                }
            >
                <Stage
                    width={size.width}
                    height={size.height}
                    style={{ width: "100%", height: "100%" }}
                >
                    <Layer>
                        <Line
                            points={points}
                            stroke="blue"
                            fill={polygon.bgColor ?? "rgba(0, 0, 255, 0.3)"}
                            strokeWidth={2}
                            closed={true}
                        />
                    </Layer>
                </Stage>
            </div>
        </Draggable>
    );
}


export const GenerateNewPipe = ({
    multiplePipe,
    activeTabIndex,
    setPipePosition,
    setUpdatedMultiplePipe,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    dashOffset
}) => {
    return (
        multiplePipe.length > 0 &&
        multiplePipe.map((pipe, index) => {
            if (pipe.tabIndex !== activeTabIndex) return null;
            return (
                <PipeWidget
                    key={index}
                    index={index}
                    pipe={pipe}
                    setPipePosition={setPipePosition}
                    setUpdatedMultiplePipe={setUpdatedMultiplePipe}
                    multiplePipe={multiplePipe}
                    activeTabIndex={activeTabIndex}
                    setDeviceMenuPosition={setDeviceMenuPosition}
                    setClickedDeviceIndex={setClickedDeviceIndex}
                    setIsDeviceMenu={setIsDeviceMenu}
                    setSelectedDevice={setSelectedDevice}
                    setCurrentDevice={setCurrentDevice}
                    tempImages={tempImages}
                    setTempImages={setTempImages}
                    setUpdatedImages={setUpdatedImages}
                    setAddedText={setAddedText}
                    setBgColor={setBgColor}
                    setTextBgColor={setTextBgColor}
                    setTextColor={setTextColor}
                    setWidgetTextColor={setWidgetTextColor}
                    setFontSize={setFontSize}
                    setTextFontSize={setTextFontSize}
                    setTextAlignVertically={setTextAlignVertically}
                    setTextAlignHorizontally={setTextAlignHorizontally}
                    dashOffset={dashOffset}
                    bgColor={pipe?.bgColor}
                    textColor={pipe?.textColor}

                />
            );
        })
    );
};

function PipeWidget({ pipe, index, setPipePosition, setUpdatedMultiplePipe, multiplePipe,
    activeTabIndex,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    dashOffset,
    bgColor,
    textColor
}) {
    const containerRef = useRef(null);
    const [size, setSize] = useState({ width: pipe?.width, height: pipe?.height });
    const [points, setPoints] = useState([]);

    // useEffect(() => {
    //     const observer = new ResizeObserver(() => {
    //         if (containerRef.current) {
    //             const { clientWidth, clientHeight } = containerRef.current;
    //             setSize({ width: clientWidth, height: clientHeight });

    //             const copied = [...multiplePipe];
    //             copied[index] = { ...copied[index], width: clientWidth, height: clientHeight };
    //             setUpdatedMultiplePipe(copied);
    //         }
    //     });

    //     if (containerRef.current) observer.observe(containerRef.current);
    //     return () => observer.disconnect();
    // }, []);

    useEffect(() => {
        if (multiplePipe.length > 0) {

            const scaleX = size.width / pipe.width;
            const scaleY = size.height / pipe.height;

            const scaledPoints = pipe.points.map((val, i) =>
                i % 2 === 0 ? val * scaleX : val * scaleY
            );

            const copiedMultiplePolygone = [...multiplePipe];
            copiedMultiplePolygone[index].points = scaledPoints;
            setUpdatedMultiplePipe(copiedMultiplePolygone);

        }
    }, [size, multiplePipe]);

    const strokeOuter = 14;
    const strokeInner = 10;
    const padding = strokeOuter;

    useEffect(() => {

        const paddedPoints = pipe.points.map((val, i) =>
            val + padding
        );

        setPoints(paddedPoints)

    }, [])




    return (
        <Draggable
            bounds="parent"
            onStop={(e, data) =>
                handleDeviceDrop(e, data, index, pipe.type, {
                    setPipePosition,
                    pipe
                })
            }
        >
            <div
                ref={containerRef}
                style={{
                    position: 'absolute',
                    left: `${pipe.x - padding}px`, // shift left
                    top: `${pipe.y - padding}px`,  // shift top
                    width: `${Number(pipe.width) + padding * 2}px`, // extra padding
                    height: `${Number(pipe.height) + padding * 2}px`,
                    resize: 'both',
                    overflow: 'visible',
                    pointerEvents: 'auto',
                    zIndex: pipe.zIndex ? pipe.zIndex : "1"
                }}
                className={styles.addImg}
                onContextMenu={(event) =>
                    handleDeviceMenu(
                        event,
                        index,
                        pipe,
                        pipe.type,
                        {
                            activeTabIndex,
                            setDeviceMenuPosition,
                            setClickedDeviceIndex,
                            setIsDeviceMenu,
                            setSelectedDevice,
                            setCurrentDevice,
                            tempImages,
                            setTempImages,
                            setUpdatedImages,
                            setAddedText,
                            setBgColor,
                            setTextBgColor,
                            setTextColor,
                            setWidgetTextColor,
                            setFontSize,
                            setTextFontSize,
                            setTextAlignVertically,
                            setTextAlignHorizontally
                        }
                    )
                }
            >
                <Stage
                    width={Number(pipe.width) + padding * 2}
                    height={Number(pipe.height) + padding * 2}
                    style={{ width: '100%', height: '100%' }}>
                    <Layer>
                        <Line
                            points={points}
                            stroke={textColor || "#444"}
                            strokeWidth={strokeOuter}
                            lineCap="butt"
                            lineJoin="round"
                            shadowForStrokeEnabled={false}
                        />
                        <Line
                            points={points}
                            stroke={bgColor || "#a8c4d9"}
                            strokeWidth={strokeInner}
                            lineCap="butt"
                            lineJoin="round"
                            shadowForStrokeEnabled={false}
                        // dash={[20, 20]}
                        // dashOffset={dashOffset}
                        />

                    </Layer>
                </Stage>
            </div>
        </Draggable>
    );
}











